const alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
                  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

function performVigenere(key, text, direction) {
   key = key.toUpperCase()
   text = text.toUpperCase()
   let result = []
   for (let i = 0; i < text.length; i++) {
     let letter = text[i]
     let keyLetter = key[i % key.length]
     let shiftAmount = alphabet.indexOf(keyLetter)
     if (alphabet.indexOf(letter) === -1) {
       result.push(letter)
     } else {
	result.push(String.fromCharCode(mod((letter.charCodeAt(0) - 65 + direction * shiftAmount), 26) + 65))
     }
   }
   return result.join('')
}

function mod(a, m) {
  let x = a % m
  while (x < 0) {
    x += m
  }
  return x
}

function encryptVigenere(key, text) {
  return performVigenere(key, text, 1)
}

function decryptVigenere(key, text) {
  return performVigenere(key, text, -1)
}

function validateKey(key) {
  key = key.toUpperCase()
  for (let i = 0; i < key.length; i++) {
    if (alphabet.indexOf(key[i]) === -1) {
      return false
    }
  }
  return true
}

export default {encryptVigenere, decryptVigenere, validateKey}
